export default "__VITE_ASSET__Tozm3iIb__"